import { Component, Input } from '@angular/core';
import { FormDataService } from '@app/_core/services/form-data.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-attachments-view',
  templateUrl: './attachments-view.component.html',
  styleUrls: ['./attachments-view.component.scss']
})
export class AttachmentsViewComponent {
  @Input() attachmentData: any = null;
  
  constructor(public bsModalRef: BsModalRef, private formDataService: FormDataService) {}

  close() {
    this.bsModalRef.hide();
  }

  openFile(fileUrl: any) {
    console.log('Open file:', fileUrl);
    this.formDataService.getFile(fileUrl).subscribe(res => {
      //console.log('FileData', res);
      const src = `data:${res?.MimeType};base64,${res?.result}`;
      const link = document.createElement('a');
      link.href = src;
      link.download = res?.fileName;
      link.click();
      link.remove();
    });
  }
}
